const hepatogramaModel = () => {
  return {
    tgo: {
      value: "",
      unit: "",
    },
    tgp: {
      value: "",
      unit: "",
    },
    fal: {
      value: "",
      unit: "",
    },
    bt: {
      value: "",
      unit: "",
    },
    bd: {
      value: "",
      unit: "",
    },
    bi: {
      value: "",
      unit: "",
    },
    ggt: {
      value: "",
      unit: "",
    },
    n5n: {
      value: "",
      unit: "",
    },
    alb: {
      value: "",
      unit: "",
    },
    prottot: {
      value: "",
      unit: "",
    },
  };
};

const um = () => {
  return {
    bt: ["mg/dL", "mcmol/L"],
    bd: ["mg/dL", "mcmol/L"],
    bi: ["mg/dL", "mcmol/L"],
    fal: ["U/dL", "mckat/L"],
    // Bug real (auditoría 2026-08-16): "pkat/L" (pico-katal) es ~1000x más chico de lo que
    // corresponde para TGO/TGP (1 U/L ≈ 0.017 µkat/L) — typo de "p" por "mc" (la convención de
    // micro que usa el resto del archivo, ver "fal" arriba).
    tgo: ["U/L", "mckat/L"],
    tgp: ["U/L", "mckat/L"],
    ggt: ["U/L"],
    n5n: ["U/L"],
    alb: ["g/dL", "g/L"],
    prottot: ["mg/dL", "g/L"],
  };
};

export { hepatogramaModel, um };
